import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import FooterLinks from "../components/FooterLinks";
import bannerImage from "../assets/banner4.png"; // Update with the correct banner image
import { Helmet } from "react-helmet-async";
import "../Courses.css"; // Make sure to create a CSS file for styling
import '../Site.css'; 


function Courses() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const API_URL = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    if (!user) {
      navigate("/login"); // Redirect if not logged in
      return;
    }

    async function fetchUserCourses() {
      try {
        const response = await fetch(`${API_URL}/api/users/${user.Id}/courses`);
        if (!response.ok) throw new Error("Failed to fetch courses");

        const data = await response.json();
        setCourses(data.courses || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchUserCourses();
  }, [user, navigate]);

  const handleViewCourse = (courseId) => {
    navigate(`/course/${courseId}`);
  };

  return (
    <><>
      <Helmet>
        <title>PharmPrepPro - Study Guides</title>
      </Helmet>

      <BottomContainer>
        <Banner
          height="300px"
          image={bannerImage} />

        <BodyContainer>
          <h1 className="course-header">Available Study Guides</h1>

          {loading ? (
            <p className="no-courses-message">Loading study guides...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : courses.length === 0 ? (
            <p className="no-courses-message">You have no active study guide subscriptions.</p>
          ) : (
            <ul className="course-list">
              {courses.map((course) => (
                <li key={course.Id} className="course-item">
                  <span className="course-name">{course.Name}</span>
                  <button className="view-button" onClick={() => handleViewCourse(course.Id)}>
                    View Course
                  </button>
                </li>
              ))}
            </ul>
          )}
        </BodyContainer>

      </BottomContainer>
    </><FooterLinks /><Footer /></>
  );
}

export default Courses;
